// Google Fonts loader para la trinidad tipográfica editorial Brandeate
// (handoff) + las 5 fuentes script que solo se usan dentro del preview
// del producto + Fraunces como legacy (se sigue cargando porque algunas
// superficies admin todavía lo refieren; navegador lo descarta si nadie
// lo usa después).
//
// UI fonts del ADMIN (sep-2026): Geist + Geist Mono. Ver la nota de
// tipografía en css.ts — una sola familia para display, texto y datos,
// con la jerarquía construida por tamaño/peso/tracking.
//
// UI fonts (chrome del personalizador del CLIENTE):
//   Instrument Serif (display) — serif didone de alto contraste con
//                                italic. Para hero titles
//                                ("¿Qué <em>palabras</em> queréis
//                                recordar?"), nombres de producto en
//                                topbar, glifo "K" del wordmark.
//                                ital@0;1 carga regular + italic.
//   Manrope          (UI/body)  — sans humanista geométrica, variable
//                                wght. Para labels, inputs, body,
//                                botones, descripciones. Pesos
//                                400/500/600/700.
//   JetBrains Mono   (eyebrow)  — mono para "PASO X DE N", counters
//                                X/Y, eyebrows uppercase tracked.
//                                Pesos 400/500/700.
//
// Poster fonts (SOLO dentro del preview, nunca chrome):
//   Dancing Script — romántico, fluido. Default del poster.
//   Caveat — a mano, cercano.
//   Pinyon Script — caligráfico, clásico.
//   Petit Formal Script — fino, elegante.
//   Mr De Haviland — firma, vintage. (El handoff README dice
//                    "Mr Saint Delafield" pero esa fuente NO está en
//                    Google Fonts. Mr De Haviland es la que el
//                    FontPicker actual ya carga y muestra como
//                    "Mr De Hawiland" en las capturas de producción.
//                    Mantenemos paridad con producción.)
//
// Llamada desde cada frontend bootstrap (admin shell, editor, embed
// boot) una vez por documento. Subsequent calls son no-ops.
//
// Preconnect a fonts.googleapis.com + fonts.gstatic.com para que el
// browser paralelice DNS + TLS mientras parsea el resto de la página.
// display=swap → el texto nunca es invisible mientras la fuente
// streamea.
//
// En un host page (embed scenario) DOES insertar <link> tags en el
// <head> del host — intencional, el embed necesita las fuentes para
// matchear el admin. CSP-restricted hosts caen al stack local
// declarado en --dfp-font-* (Times, system sans, ui-monospace).

const LINK_ID = 'dfp-ui-fonts';

const FONT_HREF =
  'https://fonts.googleapis.com/css2' +
  // Geist + Geist Mono — la tipografía del ecosistema Brandeate y, desde
  // sep-2026, la del chrome del ADMIN entero (web, app y panel comparten
  // familia). Geist es variable: un solo fichero cubre 400..700, así que
  // pedir el rango completo no cuesta más peticiones que pedir un peso.
  '?family=Geist:wght@400..700' +
  '&family=Geist+Mono:wght@400;500' +
  // Inter — reserva declarada en --dfp-font-* y aún referida por algunas
  // superficies admin sin migrar.
  '&family=Inter:wght@400;500;600;700' +
  // Instrument Serif + Manrope + JetBrains Mono: la trinidad editorial
  // del EMBED comercial y del estudio 3D del cliente (pinada en
  // .dfp-root / .bd-overlay). No se toca: es la voz de la tienda.
  '&family=Instrument+Serif:ital@0;1' +
  '&family=Manrope:wght@400;500;600;700' +
  '&family=JetBrains+Mono:wght@400;500;700' +
  // Poster fonts (solo dentro del preview del producto)
  '&family=Dancing+Script:wght@500;600;700' +
  '&family=Caveat:wght@500;700' +
  '&family=Pinyon+Script' +
  '&family=Petit+Formal+Script' +
  '&family=Mr+De+Haviland' +
  // Legacy (Fraunces — referencias admin que aún no han migrado)
  '&family=Fraunces:opsz,wght@9..144,400..700' +
  '&display=swap';

export function injectFonts(doc: Document = document): boolean {
  if (doc.getElementById(LINK_ID)) return false;
  const head = doc.head;

  // Preconnect hints — separados del stylesheet link para que el
  // browser pueda warmup la conexión en paralelo.
  if (!head.querySelector('link[data-dfp-fonts-preconnect="api"]')) {
    const pre1 = doc.createElement('link');
    pre1.rel = 'preconnect';
    pre1.href = 'https://fonts.googleapis.com';
    pre1.dataset.dfpFontsPreconnect = 'api';
    head.appendChild(pre1);
  }
  if (!head.querySelector('link[data-dfp-fonts-preconnect="static"]')) {
    const pre2 = doc.createElement('link');
    pre2.rel = 'preconnect';
    pre2.href = 'https://fonts.gstatic.com';
    pre2.crossOrigin = 'anonymous';
    pre2.dataset.dfpFontsPreconnect = 'static';
    head.appendChild(pre2);
  }

  const link = doc.createElement('link');
  link.id = LINK_ID;
  link.rel = 'stylesheet';
  link.href = FONT_HREF;
  head.appendChild(link);
  return true;
}
